import { render, staticRenderFns } from "./GameStrategy.vue?vue&type=template&id=8a7d4056&scoped=true&"
import script from "./GameStrategy.vue?vue&type=script&lang=js&"
export * from "./GameStrategy.vue?vue&type=script&lang=js&"
import style0 from "./GameStrategy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameStrategy.vue?vue&type=style&index=1&id=8a7d4056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7d4056",
  null
  
)

export default component.exports